import { Injectable, inject } from '@angular/core';

import { SportsCacheService } from '@frontend/sports/betting-offer/feature/sports-cache';
import { LiveUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { WidgetPage } from '@frontend/sports/types/components/widget';
import { WidgetContextService } from '@frontend/sports/widget/core/feature';
import { WidgetLayoutHook } from '@frontend/sports/widget/feature/layout';

import { LiveNowLinkRegisterService } from '../../live-now-item/live-now-link-register.service';

@Injectable({ providedIn: 'root' })
export class SportLiveButtonService extends WidgetLayoutHook {
    private liveButton = inject(LiveNowLinkRegisterService);
    private context = inject(WidgetContextService);
    private cache = inject(SportsCacheService);
    private urlHelper = inject(UrlHelperService);

    constructor() {
        super(WidgetPage.SportLobby);
    }

    onResolve(): void {
        const { sportId } = this.context.getContext();

        this.cache.getSportList().subscribe((sports) => {
            const sport = sports.find((s) => s.id === sportId);
            this.liveButton.addLiveButton(sport, sport?.isEsport ? this.urlHelper.getLiveUrl(LiveUrlParam.Esports) : undefined);
        });
    }

    onDestroy(): void {
        this.liveButton.removeLiveButton();
    }
}
